import { ArrowUp } from "lucide-react";
import { scrollToSection } from "@/lib/smooth";
import { CONTACT } from "@/data/products";

const NAV = [
  { label: "About", target: "#about", testid: "footer-link-about" },
  { label: "Products", target: "#products", testid: "footer-link-products" },
  { label: "Why Us", target: "#why-us", testid: "footer-link-why-us" },
  { label: "Contact", target: "#contact", testid: "footer-link-contact" },
];

const Footer = () => (
  <footer data-testid="site-footer" className="bg-sand px-6 py-14 text-ink sm:px-12 lg:px-20">
    <div className="mx-auto max-w-7xl">
      <div className="flex flex-wrap items-center justify-between gap-8 border-b border-ink/10 pb-10">
        <img src="/logo-full.png" alt="Praveen Textiles" className="h-16 w-auto" />
        <nav className="flex flex-wrap items-center gap-7">
          {NAV.map((l) => (
            <button
              key={l.label}
              data-testid={l.testid}
              onClick={() => scrollToSection(l.target)}
              className="group relative font-body text-[13px] font-medium tracking-wide text-ink/70 transition-colors hover:text-crimson"
            >
              {l.label}
              <span className="absolute -bottom-1 left-0 h-px w-0 bg-gold transition-[width] duration-300 group-hover:w-full" />
            </button>
          ))}
        </nav>
        <button
          data-testid="back-to-top-btn"
          onClick={() => scrollToSection(0)}
          aria-label="Back to top"
          className="flex h-10 w-10 items-center justify-center rounded-full border border-crimson/40 text-crimson transition-[background-color,color] duration-300 hover:bg-gold hover:text-white"
        >
          <ArrowUp size={15} />
        </button>
      </div>
      <div className="flex flex-wrap items-center justify-between gap-4 pt-8">
        <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-clay">
          © 2026 Praveen Textiles, Chennai — Wholesale Trading.
        </p>
        <p className="hidden font-mono text-[10px] uppercase tracking-[0.22em] text-clay sm:block">
          {CONTACT.phones.map((p) => `${p.display} (${p.label})`).join(" · ")} · {CONTACT.email}
        </p>
        <p className="hidden font-mono text-[10px] uppercase tracking-[0.22em] text-clay lg:block">
          GST 33AFWPJ6755N1ZK
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
